import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-mind',
  templateUrl: './magic-uses-mind.component.html',
  styleUrls: ['./magic-uses-mind.component.css']
})
export class MagicUsesMindComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
